import React from 'react';
import { getColor } from 'core/utils';
import styled from 'styled-components';

const ErrorDiv = styled.div`
	color: ${getColor("salmon")};
	font-weight: 700;
	padding: 8px 0;

	p {
		margin: 0;
		margin-bottom: 4px;
	}
`;

const ErrorBlock = () => (
	<ErrorDiv>
		<p>Auto-fetch failed for this card!</p>
		<p>Slug could be wrong or changed or listing is inactive</p>
		<p>This is only viewable by Cratejoy Admins</p>
	</ErrorDiv>
);

export default ErrorBlock;
